import { useCallback, useEffect, useRef, useState } from 'react';

export enum ScrollDirections {
    Down = 'down',
    Up = 'up',
}
// copied from https://stackoverflow.com/questions/62497110/detect-scroll-direction-in-react-js for any context
const useScrollDirection = () => {
    const [scrollDir, setScrollDir] = useState<ScrollDirections>();
    const ticking = useRef(false);
    const lastScrollY = useRef(window.pageYOffset);

    const threshold = 0;

    const onScroll = useCallback(() => {
        const updateScrollDir = () => {
            const scrollY = window.pageYOffset;

            if (Math.abs(scrollY - lastScrollY.current) < threshold) {
                ticking.current = false;
                return;
            }
            setScrollDir(scrollY > lastScrollY.current ? ScrollDirections.Down : ScrollDirections.Up);
            lastScrollY.current = scrollY > 0 ? scrollY : 0;
            ticking.current = false;
        };
        if (!ticking.current) {
            window.requestAnimationFrame(updateScrollDir);
            ticking.current = true;
        }
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [scrollDir, onScroll]);

    return scrollDir;
};

export default useScrollDirection;
